export const from = 3;
export const to = 4;

export function up(schema) {
  const { logo, ...newSchema } = schema;
  return {
    ...newSchema,
    text: migrateOutros(schema.text),
    foreground: migrateLogo(schema.foreground, schema.text, schema.logo),
    version: to,
  };
}

export function down(schema) {
  return {
    ...schema,
    logo: getLegacyLogo(schema.foreground),
    text: revertOutros(schema.text),
    foreground: revertLogo(schema.foreground),
    version: from,
  };
}

function migrateOutros(allText = []) {
  return allText.map((text) => {
    // Replace outro animation preset with supported animation.
    const newAnimationPreset = getNewAnimationPreset(text.animationPreset);
    const wasOutro = newAnimationPreset !== text.animationPreset;
    return {
      ...text,
      animationPreset: newAnimationPreset,
      ...(wasOutro && { legacyAnimationPreset: text.animationPreset }),
    };
  });
}

function migrateLogo(foregroundImages = [], text, logo) {
  // If logo exists, add it to the forgeound? The structure is very similar, so I don't think it requires further transformation.
  if (logo && logo.source) {
    const outro = text.filter((element) => {
      return element.animationPreset.includes('outro');
    })[0];
    if (outro && outro.duration && outro.startTime) {
      logo.startTime = outro.startTime;
      logo.duration = outro.duration;
      const migratedLogo = {
        ...logo,
        isLogo: true,
      };
      return [...foregroundImages, migratedLogo];
    }
  }
  return foregroundImages;
}

function getNewAnimationPreset(animationPreset) {
  // Determine new animationPreset for outros
  switch (animationPreset) {
    case 'basicoutro':
      return 'zoom';
    case 'hashtagoutro':
      return 'swipeup';
    case 'simpleoutro':
      return 'fade';
    case 'splittyoutro':
      return 'stacked';
    case 'twolineroutro':
      return 'lowerthirds';
    default:
      return animationPreset;
  }
}

function revertLogo(foregroundImages = []) {
  return foregroundImages.filter((image) => !image.isLogo);
}

function getLegacyLogo(foregroundImages = []) {
  const imageToLogo = foregroundImages.find((image) => image.isLogo);
  if (imageToLogo) {
    const { isLogo, ...legacyLogo } = imageToLogo;
    return legacyLogo;
  }
  return null;
}

function revertOutros(allText = []) {
  return allText.map((text) => {
    // Revert all animationPresets to legacy value, removing the legacyAnimationPreset
    const { legacyAnimationPreset, ...legacyText } = text;
    if (legacyAnimationPreset) {
      legacyText.animationPreset = legacyAnimationPreset;
    }
    return legacyText;
  });
}

export default {
  from,
  to,
  up,
  down,
};
